import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { H5, Btn } from '../../../AbstractElements';
import { Add, Cancel, ProductImage, ProductSize, SelectSize } from '../../../Constant';
import InputControl from '../../Common/FormInputs/InputControl';

const RightForm = ({ errors, register, control }) => {
  return (
    <Col xl='6'>
      <Card>
        <CardBody>
          <div className='product-info'>
            <H5>{ProductImage}</H5>
            <InputControl label={false} maxFiles={1} multiple={false} controlInput='dropzone' control={control} className='form-control' errors={errors} register={{ ...register('product_image', { required: 'is Required.' }) }} />
            <H5 className='mt-4'>{SelectSize}</H5>
            <div className='product-group'>
              <Row>
                <Col sm='6'>
                  <InputControl control={control} controlInput='select' options={ProductSize} className='form-select' errors={errors} register={{ ...register('select_size', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='6'>
                  <InputControl control={control} controlInput='datepicker' className='form-control' errors={errors} register={{ ...register('date', { required: 'is Required.' }) }} />
                </Col>
                <Col sm='12'>
                  <InputControl controlInput='input' type='number' className='form-control' errors={errors} register={{ ...register('price', { required: 'is Required.' }) }} />
                </Col>
              </Row>
            </div>
          </div>
          <div className='mt-4 text-end'>
            <Btn type='submit' color='primary' className='me-3'>
              {Add}
            </Btn>
            <Btn color='secondary'>{Cancel}</Btn>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RightForm;
